import { getLatestInboxAgentResultFromConversationQuery } from '../../features/engagements';
import type { ApolloContext } from '../../types';
import { writeConversationFragment } from '../../util';
import { convertPubNubConversationToConversationItemFields } from './PubNubMessageReceived';

export const PubNubConversationEngagementUpdated = (
  _: any, // unused parameter
  args: { conversation: PubNubConversationModel },
  { client }: ApolloContext,
) => {
  const { conversation } = args;

  const apolloConversation =
    convertPubNubConversationToConversationItemFields(conversation);

  // PubNub event only triggers when latest engagement or summary changes, therefore rating becomes
  // moot for the latest presented state, so clear the rating.
  if (apolloConversation.lastEngagement) {
    apolloConversation.lastEngagement = {
      ...apolloConversation.lastEngagement,
      mySummaryRating: null,
    };
  }

  // First, update the conversation fragment in the cache
  writeConversationFragment({
    client,
    conversation: apolloConversation,
    withLastAppointment: true,
    withLastChannel: false,
    withLastRepairOrder: true,
  });

  // Then, update the latest inbox agent result in the cache
  const lastEngagement = conversation.last_engagement;
  client.cache.updateQuery(
    {
      query: getLatestInboxAgentResultFromConversationQuery,
      variables: { conversationId: conversation.id },
    },
    data => {
      if (!data) return;

      return {
        conversation: {
          __typename: 'ConversationQL' as const,
          id: conversation.id,
          lastEngagement: lastEngagement
            ? {
                __typename: 'EngagementQL' as const,
                id: lastEngagement.id,
                latestInboxAgentResult: lastEngagement.latest_inbox_agent_result
                  ? {
                      __typename: 'EngagementInboxAgentResultQL' as const,
                      id: lastEngagement.latest_inbox_agent_result.id,
                      summary: lastEngagement.latest_inbox_agent_result.summary,
                      sentiment:
                        lastEngagement.latest_inbox_agent_result.sentiment,
                      sentimentValue:
                        lastEngagement.latest_inbox_agent_result
                          .sentiment_value,
                      topics:
                        lastEngagement.latest_inbox_agent_result.topics || [],
                      predictedMessageIntents:
                        lastEngagement.latest_inbox_agent_result
                          .predicted_message_intents,
                    }
                  : null,
              }
            : null,
        },
      };
    },
  );
};
